import { useAuth } from "@/context/AuthContext";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import ChangePassword from "./ChangePassword";

export default function Admin() {
  const { admin, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen bg-[#EAF0EE] flex items-center justify-center text-charcoal-500">Loading…</div>;
  }
  if (!admin) return <AdminLogin />;
  if (admin.must_change_password) return <ChangePassword forced />;
  return <AdminDashboard />;
}
